/**
 * Determines the API URL based on the current domain
 *
 * Examples:
 * - spa.syndeo.uk -> https://api.syndeo.uk/graphql
 * - spa.syndeo.rs -> https://api.syndeo.rs/graphql
 * - spa.syndeo.local -> http://localhost:9000/graphql
 * - localhost -> http://localhost:9000/graphql
 */

export const getApiUrl = (): string => {
  const hostname = window.location.hostname;

  // Localhost or local development
  if (hostname === 'localhost' || hostname.includes('.local')) {
    return 'http://localhost:9000/graphql';
  }

  // Extract domain parts
  const parts = hostname.split('.');

  // For domains like spa.syndeo.uk or spa.syndeo.rs
  // We want to construct api.syndeo.uk or api.syndeo.rs
  if (parts.length >= 2) {
    const baseDomain = parts.slice(-2).join('.'); // Gets 'syndeo.uk' or 'syndeo.rs'
    return `https://api.${baseDomain}/graphql`;
  }

  // Fallback to localhost if we can't determine
  console.warn('Could not determine API URL from hostname:', hostname);
  return 'http://localhost:9000/graphql';
};

export default getApiUrl;
